import { Sparkles, BookOpen, Target, Gem, Building2, Search } from 'lucide-react';
import { SectionPageEditor } from '@/components/admin/SectionPageEditor';
import type { SectionDef } from '@/components/admin/SectionPageEditor';

// pages/about/page.tsx is a single file (no components/ subfolder, no
// dead files to exclude). All 22 live about.* keys are covered below; 3
// orphaned keys (mission.label, values.label, values.heading — leftover
// from an earlier layout) are excluded. No images anywhere on this page.
const ABOUT_SECTIONS: SectionDef[] = [
  {
    key: 'hero',
    title: 'Hero',
    icon: Sparkles,
    texts: [
      { key: 'about.hero.label', label: 'Eyebrow Label' },
      { key: 'about.hero.heading', label: 'Heading' },
      { key: 'about.hero.subtitle', label: 'Subtitle' },
    ],
  },
  {
    key: 'story',
    title: 'Our Story',
    icon: BookOpen,
    texts: [
      { key: 'about.story.heading', label: 'Heading' },
      { key: 'about.story.p1', label: 'Paragraph 1', long: true },
      { key: 'about.story.p2', label: 'Paragraph 2', long: true },
    ],
  },
  {
    key: 'mission',
    title: 'Mission',
    icon: Target,
    texts: [
      { key: 'about.mission.heading', label: 'Heading' },
      { key: 'about.mission.body', label: 'Body Text', long: true },
    ],
  },
  {
    key: 'values',
    title: 'Values',
    icon: Gem,
    texts: [
      { key: 'about.values.pillar1.title', label: 'Pillar 1 — Title' },
      { key: 'about.values.pillar1.desc', label: 'Pillar 1 — Description' },
      { key: 'about.values.pillar2.title', label: 'Pillar 2 — Title' },
      { key: 'about.values.pillar2.desc', label: 'Pillar 2 — Description' },
      { key: 'about.values.pillar3.title', label: 'Pillar 3 — Title' },
      { key: 'about.values.pillar3.desc', label: 'Pillar 3 — Description' },
    ],
  },
  {
    key: 'company',
    title: 'Company Information',
    icon: Building2,
    note: 'Legal/registration details — edit carefully, these are compliance-facing.',
    texts: [
      { key: 'about.company.heading', label: 'Heading' },
      { key: 'about.company.siteDesc', label: 'Site Description' },
      { key: 'about.company.concern', label: 'Concern / Business Name' },
      { key: 'about.company.entity', label: 'Legal Entity' },
      { key: 'about.company.bin', label: 'BIN' },
      { key: 'about.company.tin', label: 'TIN' },
      { key: 'about.company.address', label: 'Address' },
      { key: 'about.company.tradeLicense', label: 'Trade License No.' },
    ],
  },
  {
    key: 'seo',
    title: 'SEO',
    icon: Search,
    note: 'Shown in Google search results and social media link previews — not visible on the page itself.',
    texts: [
      { key: 'seo.about.title', label: 'Meta Title', long: true },
      { key: 'seo.about.description', label: 'Meta Description', long: true },
    ],
  },
];

export default function AdminAboutPage() {
  return <SectionPageEditor pageKey="about" title="About" sections={ABOUT_SECTIONS} />;
}
